<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101305"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.currency.serialNumber')">
            <el-input-number
              v-model="editDialog.form.serialNumber"
              no="queryInput"
              :min="0"
              :controls="false"
              size="mini"
              style="width: 162px"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.code')">
            <el-input v-model="editDialog.form.code" no="code" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.localName')">
            <el-input v-model="editDialog.form.localName" no="localName" />
          </el-form-item>
          <el-form-item
            :label="$t('baseInfo.basicData.currency.interchangeCode')"
            :disabled="tenantId!==PLATFORM_TENANT_ID"
          >
            <el-input v-model="editDialog.form.interchangeCode" no="interchangeCode" />
          </el-form-item>
          <el-form-item
            :label="$t('baseInfo.basicData.currency.isoCode')"
            :disabled="tenantId!==PLATFORM_TENANT_ID"
          >
            <el-input v-model="editDialog.form.isoCode" no="isoCode" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.defaultFractionDigits')">
            <!--            <el-input-->
            <!--              v-model="editDialog.form.defaultFractionDigits"-->
            <!--              type="number"-->
            <!--              min="1"-->
            <!--              @blur="fractionDigitsBlur"-->
            <!--            />-->
            <el-select v-model="editDialog.form.defaultFractionDigits" no="defaultFractionDigits" style="width: 160px">
              <el-option
                v-for="item in fractionDigits"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.symbol')">
            <el-input v-model="editDialog.form.symbol" no="symbol" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.carryRule')">
            <el-select v-model="editDialog.form.carryRule" no="carryRule" style="width: 160px">
              <el-option
                v-for="item in carryRules"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Information.ExchangeRateDecimalPlaces')">
            <el-input-number
              v-model="editDialog.form.rateFractionDigits"
              no="rateFractionDigits"
              :min="0"
              :max="8"
              controls-position="right"
              size="mini"
              style="width: 162px"
              @blur="editDialog.form.rateFractionDigits=editDialog.form.rateFractionDigits||0"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('CargoMsg.Cargo_SelectAddPlatformCurrency')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-currency />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseCurrency from './baseCurrency'
import { getUserInfo } from '@/utils/auth'
import { getCurrencyList, getCurrenciesByPlatform, saveCurrency, addCurrencyByPlatform, saveCurrencies, delCurrency } from '@/api/basicData/currency'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'

export default {
  name: 'Currency',
  components: { baseCurrency },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.name'),
          field: 'name',
          width: 150
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.localName'),
          field: 'localName',
          width: 150
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.interchangeCode'),
          field: 'interchangeCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.isoCode'),
          field: 'isoCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.defaultFractionDigits'),
          field: 'defaultFractionDigits',
          width: 120
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.symbol'),
          field: 'symbol',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.remarks'),
          field: 'remarks',
          width: 150
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.carryRule'),
          field: 'carryRule',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.carryRuleLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Information.ExchangeRateDecimalPlaces'),
          field: 'rateFractionDigits',
          width: 120
        }
      ],
      rowData: null,
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          localName: '',
          interchangeCode: '',
          isoCode: '',
          defaultFractionDigits: '',
          symbol: '',
          remarks: '',
          carryRule: 0,
          rateFractionDigits: 6
        }
      },
      platformDialog: {
        visible: false
      },
      fractionDigits: [], // 小数位
      carryRules: [] // 进位规则
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    // 默认小数位数，可使用 0、1、2  ，其他不可选
    this.fractionDigits.push({ label: '0', value: 0 })
    this.fractionDigits.push({ label: '1', value: 1 })
    this.fractionDigits.push({ label: '2', value: 2 })
    // 下拉选择“四舍五入”或“舍位”
    this.carryRules.push({ label: this.$t('baseInfo.basicData.currency.rounding'), value: 0 })
    this.carryRules.push({ label: this.$t('baseInfo.basicData.currency.truncation'), value: 1 })
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getCurrencyList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getCurrenciesByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: 1,
          code: '',
          name: '',
          localName: '',
          interchangeCode: '',
          isoCode: '',
          defaultFractionDigits: '',
          symbol: '',
          remarks: '',
          carryRule: 0,
          rateFractionDigits: 6
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_SelectAddPlatformCurrency')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.form.serialNumber = this.editDialog.form.serialNumber ? this.editDialog.form.serialNumber : 1
        this.editDialog.title = this.$t('CargoMsg.Cargo_CurrencyMaintenance')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    fractionDigitsBlur() {
      const form = this.editDialog.form
      const val = Number(form.defaultFractionDigits)
      if (isNaN(val)) {
        form.defaultFractionDigits = ''
        return
      }
      form.defaultFractionDigits = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.serialNumber && Number(form.serialNumber) !== 0) {
        self.$message.warning(self.$t('baseInfo.basicData.currency.serialNumberCheck'))
        return
      }
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.currency.codeCheck'))
        return
      }
      if (!form.name) {
        self.$message.warning(self.$t('baseInfo.basicData.currency.nameCheck'))
        return
      }
      if (!form.interchangeCode) {
        self.$message.warning(self.$t('baseInfo.basicData.currency.interchangeCodeCheck'))
        return
      }
      if (!form.isoCode) {
        self.$message.warning(self.$t('baseInfo.basicData.currency.isoCodeCheck'))
        return
      }
      if (!form.defaultFractionDigits && Number(form.defaultFractionDigits) !== 0) {
        self.$message.warning(self.$t('baseInfo.basicData.currency.defaultFractionDigitsCheck'))
        return
      }
      let saveFunc = saveCurrency
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addCurrencyByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
        CurrencyUtil.currencyMap.clear()
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delCurrency(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
          CurrencyUtil.currencyMap.clear()
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseCurrency) {
        document.resetBaseCurrency()
      } else {
        setTimeout(() => {
          document.resetBaseCurrency()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseCurrencyRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          serialNumber: item.serialNumber,
          code: item.code,
          name: item.name,
          localName: item.localName,
          interchangeCode: item.interchangeCode,
          isoCode: item.isoCode,
          defaultFractionDigits: item.defaultFractionDigits,
          symbol: item.symbol,
          remarks: item.remarks,
          carryRule: item.carryRule,
          rateFractionDigits: item.rateFractionDigits
        })
      }
      saveCurrencies(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    }
  }
}
</script>

<style>
</style>
